module.exports = __webpack_public_path__ + "img/15.72988ef4.jpg";